import { sub } from "date-fns";

export const lg_register = {
  register_th: {
    title: "สร้างบัญชี Dmeets",
    subtitle1: "เริ่มการประชุมอย่างปลอดภัย ไม่ว่าจะเป็นในด้านการเรียนรู้ หรือการทำงานร่วมกัน",
    subtitle2: "🔒 ข้อมูลของท่านได้รับการจัดเก็บอย่างปลอดภัยในประเทศไทยและเป็นไปตามกฏ PDPA",
    tg_check: "สมาชิก",
    tg_uncheck: "ผู้เยี่ยมชม",
    sl_company: "เลือกบริษัท",
    sl_department: "เลือกแผนก",
    txt_fname: "ชื่อ",
    txt_lname: "นามสกุล",
    email: "อีเมล",
    email_place: "exam@email.com",
    dtp_birthday: "วันเดือนปีเกิด",
    txt_phone: "หมายเลขโทรศัพท์มือถือ",
    txt_company_number: "หมายเลขสมาชิก (ถ้ามี)",
    txt_password: "รหัสผ่าน",
    txt_password_confirm: "ยืนยันรหัสผ่าน",
    btn_cancel: "ยกเลิก",
    btn_register: "สร้างบัญชีผู้ใช้",
    dialog_check_data: "กรุณาตรวจสอบข้อมูล",
    dialog_email_used: "Email นี้ถูกใช้งานแล้ว กรุณากรอก Email ใหม่",
    dialog_empty_email: "กรุณากรอกข้อมูล Email",
    dialog_empty_password: "กรุณากรอกข้อมูล Password",
    dialog_company_code:
      "หมายเลขสมาชิก ต้องมีความยาว 6 ตัวอักษร,ต้องมีตัวเลขอย่าน้อง 1 ตัวเลข และ ต้องมีตัวอักษรอย่าน้อง 1 ตัวอักษร",
    dialog_empty_password_confirm: "กรุณาตรวจสอบ Confirm Password",
    dialog_save: "ลงทะเบียนสำเร็จ",
    dialog_save_success: "บัญชีของคุณถูกสร้างเรียบร้อยแล้ว",
    dialog_save_fail: "บันทึกข้อมูลไม่สำเร็จ",
    messageAlert: "ไม่สามารถลงทะเบียนได้ โปรดลองภายหลัง",
    company_tooltip:
      "หมายเลขสมาชิก คือ รหัสประจำตัวที่ระบบได้ออกให้สำหรับ Admin ของบริษัทท่าน กรณีบริษัทท่านยังไม่ได้รับหมายเลขสมาชิก หรือต้องการสมัครใหม่ กรุณาติดต่อ contact@dcm.co.th",
    rules_commond: "บังคับกรอกข้อมูล",
    rules_password: "ต้องการรหัสผ่าน",
    rules_password2:
      "จะต้องประกอบด้วยอักขระอย่างน้อย 8 ตัว รวมถึงตัวเลขหนึ่งตัว อักษรตัวพิมพ์ใหญ่หนึ่งตัว และอักขระพิเศษหนึ่งตัว",
    rules_password_confirm: "รหัสผ่านไม่ตรงกัน",
    rules_phone: "เบอร์โทรไม่ถูกต้อง ใส่ 10 หลักเท่านั้น",
    // rules_code:"หมายเลขสมาชิกไม่ถูกต้อง อย่างน้อย 6 ตัวอักษร อย่างน้อยหนึ่งตัวอักษรและหนึ่งตัวเลข",
    rules_code:"หมายเลขสมาชิกไม่ถูกต้อง อย่างน้อย 6 ตัวอักษร",
    rules_email: "กรุณากรอกอีเมลที่ถูกต้อง",
    reset_title:"การลงทะเบียนเสร็จสิ้นเรียบร้อยแล้ว!",
    reset_subtitle1:"ยินดีต้อนรับสู่ Dmeets",
    reset_subtitle2:"บัญชีของท่านได้ถูกสร้างขึ้นเรียบร้อยแล้ว",
    reset_subtitle3:"ตอนนี้คุณพร้อมที่จะเริ่มต้นการประชุมออนไลน์ได้ทุกที่ทุกเวลา",
    reset_btn:"กลับสู่หน้าลงชื่อเข้าใช้",
    already_have_an_account:"มีบัญชีอยู่แล้วใช่ไหม?",
    login_here: "เข้าสู่ระบบที่นี่",
    validatedate_of_birth: "วันเดือนปีเกิด ต้องมากกว่า > 18 ปี",
    verify_email_title:"ยืนยันอีเมลของคุณ",
    wesend_digit_code:"เราได้ส่งรหัสยืนยัน 6 หลักไปยังอีเมล",
    enter_finish_register:"กรุณากรอกรหัสด้านล่างเพื่อดำเนินการต่อ",
    verification_code:"รหัสยืนยัน (OTP)",
    code_expire:"รหัสจะหมดอายุภายใน ",
    verify:"ยืนยัน",
    resend_code:"ส่งอีกครั้งใน",
    second:"วินาที",
    incorrect_code:"รหัสไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
    code_expire_pls_resend:"รหัสหมดอายุแล้ว กรุณาขอรหัสใหม่",
    too_many_attempts:"คุณกรอกผิดหลายครั้ง กรุณาลองใหม่อีกครั้งใน 5 นาที",
    pls_enter_full_digit:"กรุณากรอก OTP ให้ครบ 6 หลัก",
    minutes:" นาที",
  },
  register_en: {
    title: "Create Your Dmeets Account",
    subtitle1: "Start meeting securely and professionally — whether for work, learning, or collaboration.",
    subtitle2: "🔒 Your data is securely stored in Thailand and fully PDPA-compliant.",
    tg_check: "Member",
    tg_uncheck: "Visitor",
    sl_company: "Select Company",
    sl_department: "Select Department",
    txt_fname: "First Name",
    txt_lname: "Last Name",
    email: "Email",
    email_place: "exam@email.com",
    dtp_birthday: "Date of Birth",
    txt_phone: "Phone Number",
    txt_company_number: "Membership Number (if applicable)",
    txt_password: "Password",
    txt_password_confirm: "Confirm Password",
    btn_cancel: "Cancel",
    btn_register: "Create Account",
    dialog_check_data: "Please check your information",
    dialog_email_used: "Email is already used",
    dialog_empty_email: "Please enter email",
    dialog_empty_password: "Please enter password",
    dialog_company_code:
      "Membership Number must be at least 6 characters, must have at least 1 number and 1 letter",
    dialog_empty_password_confirm: "Please check confirm password",
    dialog_save: "Registration Successful",
    dialog_save_success: "Your account has been successfully created.",
    dialog_save_fail: "Save data fail",
    messageAlert:
      "Cannot submit form, please try again later.",
    company_tooltip:
      "Membership Number is an identification code issued by the system for the Admin of your company. In the event that your company has not received the Membership Number or want to apply again, please contact contact@dcm.co.th",
    rules_commond: "This is required",
    rules_password: "Password is required",
    rules_password2:
      "Must include at least 8 characters, one number, one uppercase letter and one special character.",
    rules_password_confirm: "Password not matched",
    rules_phone: "Phone number is invalid, enter 10 digits only",
    // rules_code: "Membership Number is invalid, Atleast 6 characters , at least one letter and one number",
    rules_code: "Membership Number is invalid, Atleast 6 characters",
    rules_email: "Please enter correct email",
    reset_title:"Registration was completed successfully!",
    reset_subtitle1:"Welcome to Dmeets",
    reset_subtitle2:"Your account has been created successfully.",
    reset_subtitle3:"You’re now ready to start hosting secure and professional meetings — anytime, anywhere.",
    reset_btn:"Return to Login",
    already_have_an_account:"Already have an account?",
    login_here: "Login here",
    validatedate_of_birth: "Date of Birth Must be more than > 18 years old",
    verify_email_title:"Verify your email",
    wesend_digit_code:"We sent a 6-digit code to",
    enter_finish_register:"Enter it below to finish your registration.",
    verification_code:"Verification code",
    code_expire:"Code expires in",
    verify:"Verify",
    resend_code:"Resend Code in ",
    second:"second",
    incorrect_code:"Incorrect code. Please try again.",
    code_expire_pls_resend:"This code has expired. Please request a new one.",
    too_many_attempts:"Too many attempts. Please try again in 5 minutes.",
    pls_enter_full_digit:"Please enter the full 6-digit OTP code.",
    minutes:" minutes.",
  },
};
